import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@vue+compiler-sfc@3.5.17_eslint@9.30.1_rollup@4.44.2_typescript@5.8.3_vite@7.0.2/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}